import React, { useEffect, useState } from "react";
import googlePlay from "../assets/png/google-play.png";
import bg_Mobile from "../assets/png/bg-mobile.png";
import bg_desktop from "../assets/png/bg-desktop.png";
import { Col, Container, Row } from "react-bootstrap";

import { FaApple } from "react-icons/fa";
import { Link } from "react-router-dom";

// Define your breakpoints
const breakpoints = {
  mobile: 0,
  tablet: 768,
  desktop: 1024,
};

const getBreakpoint = (width) => {
  if (width < breakpoints.tablet) {
    return "mobile";
  } else if (width < breakpoints.desktop) {
    return "tablet";
  } else {
    return "desktop";
  }
};

const DownloadApp = () => {
  const [breakpoint, setBreakpoint] = useState(
    getBreakpoint(window.innerWidth)
  );
  const [styles, setStyles] = useState({
    minHeight: "50vh",
    height: "100%",
    background: `url(${bg_desktop})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
  });

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getBreakpoint(window.innerWidth));
      if (window.innerWidth >= 768) {
        setStyles({
          minHeight: "50vh",
          height: "100%",
          background: `url(${bg_desktop})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
        });
      } else {
        setStyles({
          minHeight: "50vh",
          height: "100%",
          background: `#fff`,
        });
      }
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Container>
      <Row style={styles}>
        {breakpoint === "mobile" && (
          <Col xs={12} md={5}>
            <div className="w-100 h-auto bg-white mb-5">
              <img
                src={bg_Mobile}
                alt="logooo"
                width={"100%"}
                height={"auto"}
                className="w-100 h-auto object-cover"
              />
            </div>
          </Col>
        )}

        <Col xs={12} md={12} lg={7}>
          <div className="d-flex flex-column justify-content-center align-items-center h-100 p-5">
            <div className="d-flex flex-column align-items-start gap-2">
              <h3
                className="font-bold fs-1 text-black"
                style={{
                  textAlign: breakpoint === "mobile" ? "center" : "left",
                }}
              >
                Get the best out of BBR Boat Rentals with our mobile app
              </h3>

              <p
                style={{
                  color: "#595959",
                  textAlign: breakpoint === "mobile" ? "center" : "left",
                }}
                className="my-4"
              >
                Enjoy faster bookings, exclusive deals, and on-the-go access to
                your rentals. Download now and experience smooth sailing with
                app-only features!
              </p>

              <div
                className="w-100 d-flex align-items-center flex-wrap gap-3 py-5"
                style={{
                  justifyContent: breakpoint === "mobile" ? "center" : "start",
                }}
              >
                <div
                  className="border rounded bg-black"
                  style={{ width: "100%", maxWidth: "200px" }}
                >
                  <Link
                    className="w-100 h-100 d-flex align-items-center gap-2 text-white py-1 px-3 "
                    target="_blank"
                    to="https://play.google.com/store/apps/details?id=com.bassboatrentals"
                  >
                    {/* <ImAndroid size={35} /> */}
                    <img src={googlePlay} alt={"Google play icon"} width={35} />
                    <div className="d-flex flex-column">
                      <span className="m-0" style={{ fontSize: "12px" }}>
                        Get It On
                      </span>
                      <h4
                        className="font-bold fs-4 m-0"
                        style={{ whiteSpace: "nowrap", lineHeight: "28px" }}
                      >
                        Google Play
                      </h4>
                    </div>
                  </Link>
                </div>
                <div
                  className="border rounded bg-black"
                  style={{ width: "100%", maxWidth: "200px" }}
                >
                  <Link
                    className="w-100 h-100 d-flex align-items-center gap-2 text-white py-1 px-3"
                    target="_blank"
                    to="https://apps.apple.com/us/app/bbr-boat-rentals/id6744067577"
                  >
                    <FaApple size={35} />
                    {/* <img src={googlePlay} alt={"Google play icon"} width={35} /> */}
                    <div className="d-flex flex-column">
                      <span className="m-0" style={{ fontSize: "12px" }}>
                        Download on the
                      </span>
                      <h4
                        className="font-bold fs-4 m-0"
                        style={{ whiteSpace: "nowrap", lineHeight: "28px" }}
                      >
                        App Store
                      </h4>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default DownloadApp;
